// extracted by mini-css-extract-plugin
module.exports = {"title":"historytabdata_title__2Gxxu","overAll":"historytabdata_overAll__23BQM"};